//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { catchError, lastValueFrom, map, Observable, of, throwError } from 'rxjs';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { TypeCurrencySymbolDTO } from 'src/app/core/models/system/type/type-currency-symbol.dto';

@Injectable({ providedIn: 'root' })

export class TypesCurrencySymbolService {
  
  public allCurrencySymbolTypes: TypeCurrencySymbolDTO[] | undefined;

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public get(): Observable<TypeCurrencySymbolDTO[]> {
    try {
      return this.httpClientService.get<TypeCurrencySymbolDTO[]>(environment.eSimApi + eSimApiPaths.TypesCurrencySymbol);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TypeCurrencySymbolDTO[]>(environment.eSimApi + eSimApiPaths.TypesCurrencySymbol)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(typeCurrencySymbol: TypeCurrencySymbolDTO) {
    return {id: typeCurrencySymbol.id, description: typeCurrencySymbol.currencySymbolType};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }

  public refreshCurrencyTypeValues() {
    try {
      this.get()
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.allCurrencySymbolTypes=data;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
